import styled from 'styled-components';

export const Input = styled.input`
  font-size: 1em;
  padding: 4px 8px;
  margin: 0 4px;
  max-width: 150px;
`;
